"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyFetchWaterSyncStatusQuery = exports.useFetchWaterSyncStatusQuery = exports.useWaterFetchMonthMutation = exports.useWaterHistoricBackfillMutation = exports.useWaterSyncMutation = exports.useLazyFetchSyncStatusQuery = exports.useFetchSyncStatusQuery = exports.useFetchMonthMutation = exports.useHistoricBackfillMutation = exports.useSyncTelemetryMutation = exports.telemetryApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.telemetryApi = (0, react_1.createApi)({
    reducerPath: "telemetryApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["syncStatus"],
    endpoints: function (builder) { return ({
        syncTelemetry: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/sync",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        historicBackfill: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/historic-backfill",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        fetchMonth: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/fetch-month",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        fetchSyncStatus: builder.query({
            query: function (obj) { return ({
                url: "/v1/telemetry/sync-status",
                method: "GET",
                params: { clientId: obj.clientId },
            }); },
            providesTags: ["syncStatus"],
        }),
        // Water telemetry endpoints
        waterSync: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/water-sync",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        waterHistoricBackfill: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/water-historic-backfill",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        waterFetchMonth: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/telemetry/water-fetch-month",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["syncStatus"],
        }),
        fetchWaterSyncStatus: builder.query({
            query: function (obj) { return ({
                url: "/v1/telemetry/water-sync-status",
                method: "GET",
                params: { clientId: obj.clientId },
            }); },
            providesTags: ["syncStatus"],
        }),
    }); },
});
exports.useSyncTelemetryMutation = exports.telemetryApi.useSyncTelemetryMutation, exports.useHistoricBackfillMutation = exports.telemetryApi.useHistoricBackfillMutation, exports.useFetchMonthMutation = exports.telemetryApi.useFetchMonthMutation, exports.useFetchSyncStatusQuery = exports.telemetryApi.useFetchSyncStatusQuery, exports.useLazyFetchSyncStatusQuery = exports.telemetryApi.useLazyFetchSyncStatusQuery, exports.useWaterSyncMutation = exports.telemetryApi.useWaterSyncMutation, exports.useWaterHistoricBackfillMutation = exports.telemetryApi.useWaterHistoricBackfillMutation, exports.useWaterFetchMonthMutation = exports.telemetryApi.useWaterFetchMonthMutation, exports.useFetchWaterSyncStatusQuery = exports.telemetryApi.useFetchWaterSyncStatusQuery, exports.useLazyFetchWaterSyncStatusQuery = exports.telemetryApi.useLazyFetchWaterSyncStatusQuery;
